module.exports = __webpack_public_path__ + "img/w17-b3.705eacd1.jpg";